// extracted by mini-css-extract-plugin
export default {"home-card":"HomeCard_home-card__LfNgc","card-title":"HomeCard_card-title__7mpvS","card-img":"HomeCard_card-img__SCTGX"};